import { useEffect } from "react";
import { useState } from "react";

const DashboardCard = ({ cardTitle, school, value, icon, color }) => {
    const [fade, setFade] = useState(false);

    useEffect(() => {
        // Add the fade class for a short duration and then remove it
        setFade(true);
        const timeout = setTimeout(() => setFade(false), 500); // Adjust the duration as needed
        return () => clearTimeout(timeout);
    }, [value]);


    return (
        <div className="col-xxl-4 col-md-6 dashboard-card w-100-mob">
            <div className="card info-card sales-card">
                <div className="card-body flex-row ">
                    <h5 className={`card-title ${color} pt-0`}> <span className="use-font">{school}</span></h5>

                    <div className="d-flex align-items-center ">
                        <div className={ `card-icon rounded-circle d-flex align-items-center justify-content-center ${color}`}>
                            <i className={`${icon}`}></i>
                        </div>
                        <div className={`ps-3`}>
                            <h6 className={`use-font ${color}`}><span className={`use-font ${fade ? 'fade' : ''}`}>{value}</span> {cardTitle}</h6>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default DashboardCard;